var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacebookCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.766 10.104a26.135 26.135 0 00-3.009-.157c-2.982 0-5.027 1.8-5.027 5.113v2.851h-3.362v3.871h3.364v9.925h4.037v-9.925h3.351l.515-3.871h-3.866V15.44c0-1.112.3-1.883 1.926-1.883h2.071z",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iYTk2ZmE1Y2EtZjhmNC00NTA5LWJlYzAtMWUxZDcwZGE5NWI2IiBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQyIDQyIj48ZGVmcz48c3R5bGU+LmJiOWJiMzE2LThhNGQtNDQ3ZS05OGYyLWNjMzk0Yzc3YjhjZXtmaWxsOiNmZmY7fS5iYjIwYWFhNC0xYTUwLTRhMjEtOWFiMy00YTA1NTA4YjAxNDZ7ZmlsbC1ydWxlOmV2ZW5vZGQ7fTwvc3R5bGU+PC9kZWZzPjxjaXJjbGUgY2xhc3M9ImJiOWJiMzE2LThhNGQtNDQ3ZS05OGYyLWNjMzk0Yzc3YjhjZSIgY3g9IjIxIiBjeT0iMjEiIHI9IjIxIi8+PHBhdGggY2xhc3M9ImJiMjBhYWE0LTFhNTAtNGEyMS05YWIzLTRhMDU1MDhiMDE0NiIgZD0iTTI2LjAwOSwxMC4xNDNBMjYuMTM1LDI2LjEzNSwwLDAsMCwyMyw5Ljk4NmMtMi45ODIsMC01LjAyNywxLjgtNS4wMjcsNS4xMTNWMTcuOTVIMTQuNjExdjMuODcxaDMuMzY0djkuOTI1aDQuMDM3VjIxLjgyMWgzLjM1MWwuNTE1LTMuODcxSDIyLjAxMlYxNS40NzljMC0xLjExMi4zLTEuODgzLDEuOTI2LTEuODgzaDIuMDcxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuMjQzIC0wLjAzOSkiLz48L3N2Zz4=";
export { SvgIconFacebookCircle as ReactComponent };